import { render, staticRenderFns } from "./userprofileTab.vue?vue&type=template&id=03882638"
import script from "./userprofileTab.vue?vue&type=script&lang=js"
export * from "./userprofileTab.vue?vue&type=script&lang=js"
import style0 from "./userprofileTab.vue?vue&type=style&index=0&id=03882638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports